module.exports = __webpack_public_path__ + "static/media/invalid-answer.ddc7fca0.png";